export enum RefetchKey {
  All = 'all',
  CustomFields = 'custom-fields',
  ProjectData = 'project-data',
  ProjectRundowns = 'project-rundowns',
  Report = 'report',
  Rundown = 'rundown',
  UrlPresets = 'url-presets',
  ViewSettings = 'view-settings',
  CssOverride = 'css-override',
  Translation = 'translation',
  Settings = 'settings',
}
